export class AppSettings {
    public static readonly ShowResultsBelowSafeHarbor = {
        show: 1,
        mention: 2,
        hide: 3,
    };
}